import { useGetRoleAssignmentQuery } from '../services/userApi';

export function useRoleAssignment() {
	const { data, ...result } = useGetRoleAssignmentQuery();

	return { data: data?.content, ...result };
}
